// extracted by mini-css-extract-plugin
export default {"arrow":"aY73Pk"};